import { render, staticRenderFns } from "./dongdong-msg-record.vue?vue&type=template&id=0ebafeaa&scoped=true"
import script from "./dongdong-msg-record.vue?vue&type=script&lang=js"
export * from "./dongdong-msg-record.vue?vue&type=script&lang=js"
import style0 from "./dongdong-msg-record.vue?vue&type=style&index=0&id=0ebafeaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ebafeaa",
  null
  
)

export default component.exports